import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { environment } from '../../../environments/environment';
import { AuthService } from '../../auth/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class DevAccessGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (!environment.DevAccess) return true;

    const token: any = this.authService.getDevToken();
    if (!token || this.authService.isDevTokenExpired(token)) {
      this.router.navigate(['/dev-login'], { queryParams: { returnUrl: state.url } });
      return false;
    }

    return true;
  }
}